module.exports = __webpack_public_path__ + "img/ford02.0d33d5d1.png";